enum ReservaDeSangueIndicacaoEnum {
  OutroEspecifique = 'OutroEspecifique',
  NaoAplica = 'NaoAplica',
  PossibilidadeDeSangramento = 'PossibilidadeDeSangramento',
  AlteracaoFuncionalDePlaquetasPorUsoDeCirculacaoExtraCorporea = 'AlteracaoFuncionalDePlaquetasPorUsoDeCirculacaoExtraCorporea',
  AlteracaoFuncionalDePlaquetasPorUsoDeAnteagregante = 'AlteracaoFuncionalDePlaquetasPorUsoDeAnteagregante',
  ProcedimentosInvasivosComPlaquetas = 'ProcedimentosInvasivosComPlaquetas',
  CirurgiaDePequenoPorteComPlaquetas = 'CirurgiaDePequenoPorteComPlaquetas',
  CirurgiaDeMedioPorteComPlaquetas = 'CirurgiaDeMedioPorteComPlaquetas',
  CirurgiaNeurologicaOuOftalmologicaComPlaquetas = 'CirurgiaNeurologicaOuOftalmologicaComPlaquetas',
  CirurgiaEmPacienteComCoagulopatia = 'CirurgiaEmPacienteComCoagulopatia',
  CirurgiaEmPacienteComCoagulopatiaNecessitandoDeReposicaoFibrogenio = 'CirurgiaEmPacienteComCoagulopatiaNecessitandoDeReposicaoFibrogenio',
}

export default ReservaDeSangueIndicacaoEnum
